module.exports = __webpack_public_path__ + "static/img/l3.ca10a117.jpg";